import { Controller } from "stimulus"
import { calendarTimeFormats, displayTimeFormat, parseServerTime } from "../writingio/local_time"

export default class extends Controller {
	static targets = ["time"]

  connect(){
    this.localizeServerTime()
  }
	localizeServerTime(){
		const targets = this.timeTargets

		targets.forEach((element) => {
			const serverTime = element.dataset.serverTimeValue || element.textContent
			if (!serverTime) { return }

			const localTime = parseServerTime(serverTime)
			if (!localTime) { return }

			const displayMode = element.dataset.localizeServerTimeDisplayMode || 'calendar'

			if (displayMode === 'format') {
				const displayFormat = element.dataset.localizeServerTimeDisplayFormat || displayTimeFormat
				element.textContent = localTime.format(displayFormat)
			} else {
				element.textContent = localTime.calendar(null, calendarTimeFormats)
			}
		})
	}
}
